
// Score

export const CLEAR_SCORE = 80; // more than or equals to this score is cleared.
export const SCORE_PARAM_ALPHA = null;
export const SCORE_PARAM_BETA = null;
export const SCORE_PARAM_OMEGA = null;
export const MAX_SCORE = 100;


// Utility

export const SPACE = ' ';


export const iconType = {
    CORRECT: require("@/assets/correct.svg"),
    CROSS: require("@/assets/cross.svg"),
    TRIANGLE: require("@/assets/triangle.svg"),
}



export const LANG = {
    EN: 'en-US',
    CN: 'zh-CN',
    JP: 'jp'
}

export const langSet = {
    US: {
        RECOGNITION: 'en-US',
        SPEECH: 'Google US English'
    },
    UK: {
        RECOGNITION: 'en-UK',
        SPEECH: 'Google UK English Female'
    },
    CN: {
        RECOGNITION: 'en-US',
        SPEECH: 'Google 普通话（中国大陆）'
    },
    JP: {

    }
}




